import { useState, useCallback } from 'react';
import { useImpression } from '../useImpression';
import { useBQ } from '../useBQ';
import { sendMixpanelWidgetImpressionEvent } from '../../utils/mixpanel';
import { MODE } from '../../../../constants';

const useAfp1Impression = (afp1, ref, onImpression) => {
    const [impression, setImpression] = useState(false);
    const [notified, setNotified] = useState(false);

    useImpression(
        useCallback(() => {
            setImpression(true);
        }, []),
        ref
    );

    /**
     * Checking afp1 because it will be defined async
     * Only relevant for api v1
     * @TODO
     * Should be removed once api v1 is removed.
     */
    if (afp1 && impression && !notified) {
        onImpression();
        setNotified(true);
    }
};

interface useWidgetImpressionProps {
    affiliateId: string;
    afp1: string;
    widgetType: MODE;
}

export const useWidgetImpression = (props: useWidgetImpressionProps, ref: React.Ref<React.ReactNode>) => {
    const { affiliateId, afp1, widgetType } = props;
    const { sendBQEvent } = useBQ();

    const onImpression = () => {
        sendBQEvent({
            type: 'nga.widget_impression',
            affiliateId,
            afp1,
            widgetType,
        });
        sendMixpanelWidgetImpressionEvent({ affiliateId, hostReference: afp1 });
    };

    useAfp1Impression(afp1, ref, onImpression);
};

interface useGigImpressionProps {
    affiliateId: string;
    afp1: string;
    gigId: number;
    widgetType: MODE;
}

export const useGigImpression = (props: useGigImpressionProps, ref: React.Ref<React.ReactNode>) => {
    const { affiliateId, afp1, gigId, widgetType } = props;

    const { sendBQEvent } = useBQ();

    const onImpression = () => {
        sendBQEvent({
            type: 'nga.gig_impression',
            gigId,
            affiliateId,
            afp1,
            widgetType,
        });
    };

    useAfp1Impression(afp1, ref, onImpression);
};
